import { RouterView } from "vue-router";
import { META_LAYOUT, META_HTML_TITLE, APP_ETAB } from "@core/constants";
import { ETAB_LAYOUTS, ETAB_ROUTES } from "@etab/config";

import { isNative } from "@core/plugins/mobile";
import { BatchManager } from "@core/plugins/batch/batch.manager";
import { ACTION_BATCH_GET_USER_DATA, GETTER_BATCH_GET_USER_DATA } from "@core/store/types";
import getRecruitmentDetailPages from "./recruitment";
import getRecruitmentsTabs from "./recruitments";
import getPlanningPages from "./planning";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.root.path,
      name: ETAB_ROUTES.dashboard.root.name,
      meta: {
        [META_HTML_TITLE]: "ETAB.PAGES.DASHBOARD.@TITLE",
        [META_LAYOUT]: ETAB_LAYOUTS.dashboard,
      },
      component: RouterView,
      redirect: { name: ETAB_ROUTES.creation.root.name },
      beforeEnter: async (to, from, next) => {
        if (isNative) {
          await BatchManager.start({
            storeAction: ACTION_BATCH_GET_USER_DATA,
            storeGetter: GETTER_BATCH_GET_USER_DATA,
            env: APP_ETAB,
          });
        }
        next();
      },
      children: [
        ...getRecruitmentDetailPages(), //
        ...getRecruitmentsTabs(),
        ...getPlanningPages(),
      ],
    },
  ];
}
